import { List, MeetingViewModel } from '@components';
import {
  getMemberIcon, IUser, useOutsideClick, useStore,
  useViewModel,
} from '@utils';
import { MeetingPlanerViewModel } from '@views';
import { observer } from 'mobx-react-lite';
import React, { FC, useCallback, useEffect } from 'react';
import { MembersStore } from '../../../store';
import { User } from '../../user';
import '../../../styles/components/memberList.scss';

interface MemberListProp {
  topOfList?: number;
  rightOfList?: number;
  editMeeting?: boolean;
  className?: string;
  isCanResetChoosedOption?: boolean;
  onClose: () => void;
  sortingRule?: (a: IUser, b: IUser) => number;
  onMemberSelect: (memberId: number) => void;
}

export const MemberList: FC<MemberListProp> = observer(({
  topOfList, rightOfList, className, isCanResetChoosedOption,
  editMeeting = false, onClose, sortingRule = () => { return 0; }, 
  onMemberSelect
}) => {
  const membersStore = useStore(MembersStore);
  const meetingPlanerViewModel = useViewModel(MeetingPlanerViewModel);
  const meetingViewModel = useViewModel(MeetingViewModel);

  const ref = useOutsideClick(onClose);

  useEffect(() => {
    const onPressEsc = ({ key }: KeyboardEvent) => key === 'Escape' && onClose();
    document.addEventListener('keydown', onPressEsc);
    return () => document.removeEventListener('keydown', onPressEsc);
  }, []);

  const onResetChoosedOptions = useCallback(
    () => editMeeting
      ? meetingViewModel.onUpdateMeeting('members', meetingViewModel.meetingData.initiator ? [meetingViewModel.meetingData.initiator] : [])
      : meetingPlanerViewModel.clearMembers()
    , []);

  const isSelected = useCallback(
    (memberId: number) =>
      editMeeting
        ? meetingViewModel.meetingData.members.some(item => item.id === memberId)
        : meetingPlanerViewModel.membersValues.some(item => item.id === memberId)
    , [meetingViewModel.meetingData.members.length, meetingPlanerViewModel.membersValues.length]);

  const onEnterPress = (user: IUser) => onMemberSelect(user.id);

  return (
    <List
      top={topOfList}
      right={rightOfList}
      itemsMaxHeight={278}
      className={`member-list ${className}`}
      items={membersStore.data}
      editMeeting={editMeeting}
      sortingRule={sortingRule}
      placeholder='Сотрудников не найдено'
      onEnterPress={onEnterPress}
      renderItem={(member) => (
        <User
          key={member.id}
          member={member}
          isSelected={isSelected(member.id)}
          memberStatus
          onClickMember={onMemberSelect}
          memberIcon={getMemberIcon(member, false, 'work-type-icon')}
        />
      )}
      headerTitle="Сотрудники"
      isCanFilter
      onClose={onClose}
      itemForFilter={((item) => item.fullName)}
      anchor={ref}
      isCanResetChoosedOption={isCanResetChoosedOption}
      onResetChoosedOptions={onResetChoosedOptions}
      resetFilter
    />
  );
});
